import { Result, ResultProps } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PrimaryButton } from 'components/button';
import successIcon from 'assets/images/MakeRequest/error-icon.svg';

interface GenericResultProps extends ResultProps {
  defaultTo?: string;
  defaultLabel?: string;
  hideDefaultExtra?: boolean;
  content?: JSX.Element;
}

export const LifeGenericResultRery = ({
  defaultLabel,
  defaultTo = '/home',
  hideDefaultExtra,
  content,
  ...others
}: GenericResultProps): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Result
      icon={<img src={successIcon} />}
      title={t('common.error.generic')}
      extra={
        !hideDefaultExtra &&
        defaultTo && [
          content,
          <PrimaryButton key="1" onClick={() => navigate(-1)}>
            {defaultLabel || t('common.error.retry')}
          </PrimaryButton>,
          <PrimaryButton key="goBack" onClick={() => navigate(defaultTo)}>
            {defaultLabel || t('common.error.returnHome')}
          </PrimaryButton>,
        ]
      }
      {...others}
    />
  );
};
